import { ColumnValueStateModel } from './column-settings.state';

export class UpdateColumns {
  public static readonly type = '[InvoiceLines] Change Column setings';

  constructor(public payload: { value: ColumnValueStateModel }) {}
}
